module.exports = __webpack_public_path__ + "9f2b674dac0a84afdf3455d8a521ccf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/2-star.svg
// module id = 974
// module chunks = 0